import { journalEntriesMolecule } from '@web-app/atoms/in-session/journalEntriesMolecule';
import { useMolecule } from 'bunshi/react';
import { useAtomValue } from 'jotai';
import { FC } from 'react';

import type { SessionFocusCardProps } from './SessionFocusCard';
import { SessionFocusCard } from './SessionFocusCard';

type Props = Omit<SessionFocusCardProps, 'journalActivity'>;

/**
 * Subscribes to journal-since-appointment state for Session Focus. Isolated so
 * it can be wrapped in an error boundary without taking down the whole Prep tab.
 */
export const SessionFocusWithJournalActivity: FC<Props> = (props) => {
  const { journalEntriesSinceLastAppointmentAtom } = useMolecule(
    journalEntriesMolecule,
  );
  const journalActivity = useAtomValue(journalEntriesSinceLastAppointmentAtom);

  return <SessionFocusCard {...props} journalActivity={journalActivity} />;
};
